import { Button, MenuItem, Select, SelectChangeEvent, TextField, Tooltip } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import InfoIcon from '@mui/icons-material/Info';
const AddReferral: React.FC = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    username: "",
    email: "",
    phone: "",
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const [redemptionType, setRedemptionType] = useState('default');
  const handleRedemptionTypeChange = (event: SelectChangeEvent) => {
    setRedemptionType(event.target.value as string);
  };
  return (
    <>
      <div className="main_title">
        <h1>Add Referral</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
          <button onClick={() => navigate("/referral")}>Referral</button>- Add Referral
        </p>
      </div>

      <div className="form full_width_img cards">
        <div className="gap_p">

          {/* Username */}
          <div className="control_group w_33">
            <label> Name</label>
            <TextField
              name="username"
              placeholder="Enter User Name"
              hiddenLabel
              fullWidth
              value={formData.username}
              onChange={handleChange}
            />
          </div>

          {/* Email */}
          <div className="control_group w_33">
            <label>Email</label>
            <TextField
              name="email"
              placeholder="Enter Email"
              hiddenLabel
              fullWidth
              value={formData.email}
              onChange={handleChange}
            />
          </div>

          {/* Phone */}
          <div className="control_group w_33">
            <label>Phone Number</label>
            <TextField
              name="phone"
              placeholder="Enter Phone Number"
              hiddenLabel
              fullWidth
              value={formData.phone}
              onChange={handleChange}
            />
          </div>
          <div className="control_group w_33">
            <label>Reedem Referral Points in <Tooltip title="These referral points will be added to your wallet once the user is registered as a vendor on Bouteek platform">
            <InfoIcon/>
            </Tooltip> </label>
            <Select
              value={redemptionType}
              onChange={handleRedemptionTypeChange}
            >
              <MenuItem disabled value="default">Select </MenuItem>
              <MenuItem value="all">Bouteek Points</MenuItem>
              <MenuItem value="promotion">Offer</MenuItem>
            </Select>
          </div>

        </div>

        <div className="btn_flx mt_20">
          <Button className="btn btn_primary">Save</Button>
        </div>
      </div>
    </>
  );
};

export default AddReferral;
